import { useSyncExternalStore } from 'react';

/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */
let online = true;
const isOnline = () => online;

function subscribe(callback: () => void): () => void {
    // revalidate on reconnected
    const onOnline = () => {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = () => {
        online = false;
        callback();
    };
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
        window.removeEventListener('online', onOnline);
        window.removeEventListener('offline', onOffline);
    };
}

/*
 * Hook to test if the browser is online. Returns true if the browser is online.
 */
export function useIsOnline(): boolean {
    return useSyncExternalStore(subscribe, isOnline);
}
